import { Box } from "@primer/react";
import { useState } from "react";
import KhoLeadInteractionEditModal from "../../pages/crm-survey/KhoLead/KhoLeadInteractionEditModal";
import PhuHuynhCSKHItem from "../phu-huynh-cskh-item";
import { useKetQuaLienHe } from "../selectbox-ket-qua-lien-he/useKetQuaLienHe";
import { useLoaiLienHe } from "../selectbox-loai-lien-he/useLoaiLienHe";
import { ICareItem } from "./careItems";

interface ICareListProps {
    items: ICareItem[];
    // Cơ sở để lấy danh mục loại / kết quả liên hệ cho modal sửa của Lead
    dm_coso_id?: number;
    onChanged: () => void;
}

// Danh sách lịch sử chăm sóc dùng chung cho CSKH, Kho Lead và hồ sơ phụ huynh (không chia nhóm)
const CareList = ({ items, dm_coso_id, onChanged }: ICareListProps) => {
    const loaiLienHes = useLoaiLienHe(dm_coso_id);
    const ketQuaLienHes = useKetQuaLienHe(dm_coso_id);
    const [editingLeadItem, setEditingLeadItem] = useState<ICareItem>();

    if (items.length === 0) {
        return (
            <Box sx={{
                py: 5, textAlign: "center", color: "fg.muted", fontSize: 1,
                border: "1px dashed", borderColor: "border.muted", borderRadius: 2,
            }}>
                Chưa có lịch sử chăm sóc.
            </Box>
        );
    }

    return (
        <Box>
            {items.map(item => (
                <PhuHuynhCSKHItem
                    key={item.id}
                    ts_chamsockhachhang={item as any}
                    onChanged={onChanged}
                    // Bản ghi từ Lead sửa bằng modal của Lead để giữ đúng cách lưu kết quả liên hệ
                    keepResult={item.isLead}
                    onEdit={item.isLead ? () => setEditingLeadItem(item) : undefined}
                />
            ))}

            {editingLeadItem && (
                <KhoLeadInteractionEditModal
                    leadId={editingLeadItem.crm_survey_respone_id ?? 0}
                    interaction={{
                        id: editingLeadItem.id,
                        crm_lead_id: editingLeadItem.crm_survey_respone_id ?? 0,
                        dm_loai_lien_he_id: editingLeadItem.dm_loai_lien_he_id ?? undefined,
                        result: editingLeadItem.ten_ket_qua_lien_he ?? undefined,
                        content: editingLeadItem.noi_dung,
                        appointment: editingLeadItem.ngay_hen_tra_loi ?? undefined,
                        note: editingLeadItem.ghi_chu,
                        created_time: editingLeadItem.ngay_tao ?? "",
                        created_user_id: 0,
                    }}
                    loaiLienHes={loaiLienHes}
                    ketQuaLienHes={ketQuaLienHes}
                    onClose={() => setEditingLeadItem(undefined)}
                    onSuccess={() => {
                        setEditingLeadItem(undefined);
                        onChanged();
                    }}
                />
            )}
        </Box>
    );
};

export default CareList;
